var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"app-icon",class:{ 'web-assistant': _vm.isWebAssistant }},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":("#" + _vm.logo)}})])}
var staticRenderFns = []

export { render, staticRenderFns }